package com.arena_web.data.dto

import kotlinx.serialization.Serializable

@Serializable
data class RegisterRequest(
    val email: String,
    val username: String,
    val password: String,
    val fullName: String? = null,
    val utmSource: String? = null,
    val utmMedium: String? = null,
    val utmCampaign: String? = null,
    val utmContent: String? = null,
    val deviceId: String? = null,
    val fbclid: String? = null,
    val fbp: String? = null,
    val ttclid: String? = null,
    val ttp: String? = null
)

@Serializable
data class LoginRequest(
    val username: String,
    val password: String
)

@Serializable
data class OAuthLoginRequest(
    val provider: String,
    val providerId: String,
    val email: String,
    val fullName: String? = null,
    val avatarUrl: String? = null,
    val dateOfBirth: String? = null,  // ISO yyyy-MM-dd
    val gender: String? = null,
    val city: String? = null,
    val country: String? = null,
    val languages: List<String>? = null,
    // Google ID token / Apple identity token; the backend trusts only its claims.
    val idToken: String? = null,
    val utmSource: String? = null,
    val utmMedium: String? = null,
    val utmCampaign: String? = null,
    val utmContent: String? = null,
    val deviceId: String? = null,
    val fbclid: String? = null,
    val fbp: String? = null,
    val ttclid: String? = null,
    val ttp: String? = null
)

@Serializable
data class AuthResponse(
    val accessToken: String,
    val refreshToken: String,
    val user: UserDto
)

@Serializable
data class LogoutRequest(
    val refreshToken: String
)

@Serializable
data class RefreshTokenRequest(
    val refreshToken: String
)

@Serializable
data class RefreshTokenResponse(
    val accessToken: String,
    val refreshToken: String
)
